module.exports = __webpack_public_path__ + "static/media/menu_icon.4eeabc96.svg";